import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { getSvgStyles } from 'baseui/icon';
import { styled } from '../../../theme/utils.js';
import { Icon } from '../icon.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Svg = forwardRef((_a, ref) => {
  var _b = _a, { title, titleId } = _b, props = __objRest(_b, ["title", "titleId"]);
  return jsxs("svg", __spreadProps(__spreadValues({}, props), { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", ref, "aria-labelledby": titleId, children: [title ? jsx("title", { id: titleId, children: title }) : null, jsx("path", { fill: "currentColor", d: "M16.9902 22H14.9902L14.0312 21.285L12.1632 15H11.8172L9.94922 21.285L8.99022 22H6.99022L6.01222 21.208L5.05022 16.691C4.40122 13.642 4.07422 10.533 4.07422 7.416V6.13C4.07422 3.505 5.43622 2 7.81022 2C9.09622 2 9.80922 2.335 10.3822 2.604C10.8722 2.834 11.2262 3 11.9902 3C12.7542 3 13.0852 2.835 13.5432 2.605C14.0832 2.335 14.7542 2 15.9902 2C18.3832 2 19.9902 4.01 19.9902 7C19.9902 10.393 19.6172 13.79 18.8822 17.098L17.9672 21.217L16.9902 22ZM15.7362 20H16.1882L16.9302 16.664C17.6342 13.498 17.9912 10.247 17.9912 7C17.9912 6.296 17.8472 4 15.9912 4C15.2272 4 14.8962 4.165 14.4382 4.395C13.8982 4.665 13.2272 5 11.9912 5C10.7802 5 10.0892 4.675 9.53322 4.414C9.04022 4.183 8.65122 4 7.81122 4C6.97122 4 6.07522 4.165 6.07522 6.13V7.419C6.07522 10.396 6.38822 13.364 7.00822 16.276L7.80122 20H8.24522L10.1132 13.715L11.0722 13H12.9112L13.8702 13.715L15.7382 20H15.7362Z" })] }));
});
const StyledSvg = styled(Svg, getSvgStyles);
const overrides = {
  Svg: {
    component: StyledSvg
  }
};
const IconTooth = forwardRef((props, ref) => jsx(Icon, __spreadValues({ ref, overrides }, props)));
IconTooth.displayName = "IconTooth";

export { IconTooth };
